export class GoogleAtuError extends Error {}
